import { ContentAssetType } from '../../../server';

const assetsCacheMap: Map<string, ContentAssetType | undefined> = new Map();

export const getCachedContentAsset = (key: string): ContentAssetType | undefined => {
    return assetsCacheMap.get(key);
};

export const setCachedContentAsset = (contentAssets: ContentAssetType[]): void => {
    contentAssets.forEach((contentAsset) => {
        assetsCacheMap.set(contentAsset.id, contentAsset);
    });
};
